import { useEffect, useRef } from 'react'

export default function usePreviousCard(card: any) {
  const prevCard = useRef()

  useEffect(() => {
    prevCard.current = card
  })

  return prevCard.current
}
